var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c(_vm.theme.components.BaseElementLayout, {
    tag: "component",
    attrs: {
      "el$": _vm.el$
    }
  }, [_c('template', {
    slot: "field"
  }, [_c('v-flex', {
    attrs: {
      "xs-12": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "success",
      "flat": "",
      "icon": ""
    },
    on: {
      "click": function click($event) {
        return _vm.refreshPurchaseOrders();
      }
    }
  }, [_c('v-icon', [_vm._v("refresh")])], 1)], 1), _vm._t("prefix"), _vm._t("label", null, {
    "slot": "label",
    "el$": _vm.el$
  }), _c('div', {
    staticClass: "plant_used"
  }, [_vm._l(this.usedPlants, function (item, index) {
    return _c('v-flex', {
      key: index,
      staticClass: "plant_used_item",
      attrs: {
        "xs12": ""
      }
    }, [_c('div', {
      staticClass: "plant_used_item-divider"
    }, [_c('hr'), _c('v-btn', {
      attrs: {
        "icon": ""
      },
      on: {
        "click": function click($event) {
          return _vm.oRemovePlant(index);
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "dark": ""
      }
    }, [_vm._v("mdi-close")])], 1)], 1), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: _vm.usedPlants[index]['select_plant'],
        expression: "usedPlants[index]['select_plant']"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "number",
        "name": "select_plant",
        "id": 'select_plant_' + index,
        "placeholder": "Describe Plant"
      },
      domProps: {
        "value": _vm.usedPlants[index]['select_plant']
      },
      on: {
        "keyup": _vm.handlePlantsModel,
        "input": function input($event) {
          if ($event.target.composing) return;
          _vm.$set(_vm.usedPlants[index], 'select_plant', $event.target.value);
        }
      }
    }), _c('v-switch', {
      attrs: {
        "inset": "",
        "label": "Was this plant hired?"
      },
      model: {
        value: _vm.usedPlants[index]['plant_hired'],
        callback: function callback($$v) {
          _vm.$set(_vm.usedPlants[index], 'plant_hired', $$v);
        },
        expression: "usedPlants[index]['plant_hired']"
      }
    }), _vm.usedPlants[index]['plant_hired'] ? _c('div', {
      staticClass: "purchase_orders"
    }, _vm._l(_vm.purchase_orders, function (po, poIndex) {
      return _c('v-flex', {
        key: po.POPH_Reference,
        attrs: {
          "xs12": ""
        }
      }, [_c('v-card', {
        attrs: {
          "raised": "",
          "tile": ""
        }
      }, [_c('v-card-title', {
        key: "title".concat(poIndex),
        staticStyle: {
          "height": "30px"
        },
        attrs: {
          "color": "gray"
        }
      }, [_vm._v("\n                " + _vm._s(po.POPH_Reference) + "\n                "), _c('v-spacer'), _vm._v("\n                £" + _vm._s(po.POPH_Total_Value_Ex_VAT_Home) + "\n              ")], 1), _c('v-card-text', {
        staticClass: "purchase_order"
      }, [_vm._v("\n                " + _vm._s(po.SUPP_Name) + "\n                "), _c('v-flex', {
        attrs: {
          "xs-12": ""
        }
      }, [_c('label', [_c('v-checkbox', {
        attrs: {
          "label": "Used"
        },
        on: {
          "click": _vm.handlePlantsModel
        },
        model: {
          value: _vm.usedPlants[index]['hire_purchase_orders'][po.POPH_Reference]['used'],
          callback: function callback($$v) {
            _vm.$set(_vm.usedPlants[index]['hire_purchase_orders'][po.POPH_Reference], 'used', $$v);
          },
          expression: "\n                        usedPlants[index]['hire_purchase_orders'][\n                          po.POPH_Reference\n                        ]['used']\n                      "
        }
      })], 1)]), _vm.usedPlants[index]['hire_purchase_orders'][po.POPH_Reference]['used'] && _vm.po_type == 'MAT' ? _c('v-flex', {
        attrs: {
          "xs-12": ""
        }
      }, [_c('v-label', [_vm._v("GRN")]), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: _vm.usedPlants[index]['hire_purchase_orders'][po.POPH_Reference]['grn'],
          expression: "\n                      usedPlants[index]['hire_purchase_orders'][\n                        po.POPH_Reference\n                      ]['grn']\n                    "
        }],
        staticClass: "form-control",
        attrs: {
          "type": "number",
          "name": po.POPH_Reference,
          "id": po.POPH_Reference,
          "placeholder": "Enter GRN number"
        },
        domProps: {
          "value": _vm.usedPlants[index]['hire_purchase_orders'][po.POPH_Reference]['grn']
        },
        on: {
          "keyup": _vm.handlePlantsModel,
          "input": function input($event) {
            if ($event.target.composing) return;
            _vm.$set(_vm.usedPlants[index]['hire_purchase_orders'][po.POPH_Reference], 'grn', $event.target.value);
          }
        }
      })], 1) : _vm._e(), _vm.usedPlants[index]['hire_purchase_orders'][po.POPH_Reference]['used'] && _vm.po_type == 'HIR' ? _c('v-flex', {
        attrs: {
          "xs-12": ""
        }
      }, [_c('v-label', [_vm._v("Off Hire Number")]), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: _vm.usedPlants[index]['hire_purchase_orders'][po.POPH_Reference]['off_hire_number'],
          expression: "\n                      usedPlants[index]['hire_purchase_orders'][\n                        po.POPH_Reference\n                      ]['off_hire_number']\n                    "
        }],
        staticClass: "form-control",
        attrs: {
          "type": "number",
          "name": po.POPH_Reference,
          "id": po.POPH_Reference,
          "placeholder": "Enter Off Hire number"
        },
        domProps: {
          "value": _vm.usedPlants[index]['hire_purchase_orders'][po.POPH_Reference]['off_hire_number']
        },
        on: {
          "keyup": _vm.handlePlantsModel,
          "input": function input($event) {
            if ($event.target.composing) return;
            _vm.$set(_vm.usedPlants[index]['hire_purchase_orders'][po.POPH_Reference], 'off_hire_number', $event.target.value);
          }
        }
      })], 1) : _vm._e()], 1)], 1)], 1);
    }), 1) : _vm._e()], 1);
  }), _c('hr'), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function click($event) {
        return _vm.onAddPlant();
      }
    }
  }, [_vm._v("\n        Add\n      ")])], 2), _vm._t("suffix")], 2), _vm._t("info", null, {
    "slot": "info",
    "el$": _vm.el$
  }), _vm._t("before", null, {
    "slot": "before",
    "el$": _vm.el$
  }), _vm._t("between", null, {
    "slot": "between",
    "el$": _vm.el$
  }), _vm._t("error", null, {
    "slot": "error",
    "el$": _vm.el$
  }), _vm._t("after", null, {
    "slot": "after",
    "el$": _vm.el$
  })], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }